export default __webpack_public_path__ + "static/media/sweetpressedhaste.2f1425d4.jpg";